import React from 'react'
import { Div } from 'glamorous'

import Icon, { ICON_ALERT } from 'components/common/Icon'
import Text from 'components/common/Text'

const ReportContent = props => {
  return (
    <Div
      paddingTop={30}
      paddingLeft={24}
      paddingRight={24}
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <Icon width={60} height={60} path={ICON_ALERT} />
      <Div width="100%" paddingTop={20} paddingBottom={14}>
        <Text size={16} color="black" css={{ marginBottom: 12 }}>
          Report User
        </Text>
        <Text size={14} color="grey">
          Tell us whats wrong with this profile.
        </Text>
      </Div>
    </Div>
  )
}

export default ReportContent



// WEBPACK FOOTER //
// ./src/components/modal/ReportContent.js